module.exports = __webpack_public_path__ + "img/sm-linkedin.0f48c00f.png";